import { render, staticRenderFns } from "./riskSummaryTabComponent.vue?vue&type=template&id=35ec435c"
import script from "./riskSummaryTabComponent.vue?vue&type=script&lang=js"
export * from "./riskSummaryTabComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports